'use client';

import { useRef, useState } from 'react';

import { Stack } from '@backyard-ui/core';

import { type ItemId } from '@/infra/services/catalog/model';
import { type Order } from '@/infra/services/catalog/review/model';
import { useDefaultStore } from '@/presenters/store/catalog/default';

import { useReviews } from './hooks';
import { Item } from './Item';
import { Pagination } from './Pagination';

interface ReviewsProps {
  itemId: ItemId;
}

function Reviews(props: ReviewsProps) {
  const { itemId } = props;

  const initialReviews = useDefaultStore((store) => store.review.reviews);

  const [order, setOrder] = useState<Order>('usefulness');
  const [currentPage, setCurrentPage] = useState(1);

  const paginationRef = useRef<HTMLDivElement>(null);

  const { data: response, isFetching } = useReviews(
    {
      order,
      page: currentPage,
      itemId,
    },
    { initialData: initialReviews && { data: initialReviews } }
  );

  const scrollToPagination = () =>
    paginationRef.current?.scrollIntoView({ behavior: 'instant' });

  return (
    <Pagination
      ref={paginationRef}
      onNext={() => {
        scrollToPagination();
        setCurrentPage(currentPage + 1);
      }}
      onPrev={() => {
        scrollToPagination();
        setCurrentPage(currentPage - 1);
      }}
      onReorder={(order) => setOrder(order)}
      totalReviewsCount={response?.data.totalReviews || 0}
      currentPage={currentPage}
      pageSize={6}
      isFetching={isFetching}
      orderItems={[
        { name: 'Mais útil', value: 'usefulness' },
        { name: 'Mais relevantes', value: 'lowRating' },
        { name: 'Maior nota', value: 'highRating' },
        { name: 'Mais recente', value: 'lastSent' },
      ]}
    >
      <Stack direction="column" spacing="20">
        {response?.data.reviews?.map((review, index) => (
          <Item review={review} key={index} />
        ))}
      </Stack>
    </Pagination>
  );
}

export default Reviews;
